import { render, staticRenderFns } from "./background-setting.vue?vue&type=template&id=b213a1e4&scoped=true"
import script from "./background-setting.vue?vue&type=script&lang=js"
export * from "./background-setting.vue?vue&type=script&lang=js"
import style0 from "./background-setting.vue?vue&type=style&index=0&id=b213a1e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b213a1e4",
  null
  
)

export default component.exports